let $arrow = $('.arrow-up');
let $windows = $(window);
let $document = $(document);

$arrow.on('click', () => {
	$('html, body').animate({scrollTop: 0}, 500);
});

$document.on('scroll', () => {
	if ($windows.scrollTop() >= 300) {
		$arrow.fadeIn(300);
	} else {
		$arrow.fadeOut(300);
	}
});
